import { RyeIcon } from "../rye/RyeIcon";
import { buildClasses } from "../utils/buildClasses";

export function FilterIcon({
  hasActiveFilter,
  onClick,
}: {
  hasActiveFilter: boolean;
  onClick?: () => void;
}): JSX.Element {
  return (
    <RyeIcon
      name="filter_list"
      size="sm"
      fill={true}
      className={buildClasses({
        if: hasActiveFilter,
        then: buildClasses("text-purple", "cursor-pointer", "select-none"),
        else: buildClasses(
          "text-on-surface-400",
          "cursor-pointer",
          "select-none",
          "invisible",
          "group-hover:visible",
        ),
      })}
      onClick={onClick}
      tooltip={hasActiveFilter ? "Edit filter" : "Add filter"}
    />
  );
}
